module.exports = __webpack_public_path__ + "img/header-weddingRingsClassic@2x.f3c3eb4.jpg";